<div class="modal-content rounded-0 sign-up">
  <div class="modal-header">
    <button type="button" class="float-right btn-close" (click)="closeModal()">
      <img src="/images/close-lg.svg" />
    </button>
    <h4 class="modal-title text-center w-100" id="modal-basic-title">
      {{ "projectDetails.projectDetails" | cxTranslate }}
    </h4>
  </div>
  @if (projectDetail) {
    <div class="modal-body">
      <h5 class="titleSec">
        {{ "projectDetails.newProjectDetails" | cxTranslate }}
      </h5>
      <div class="row mb-3">
        <div class="col-md-12">
          <label for="projectName" class="form-label">
            {{ "projectDetails.projectName" | cxTranslate }}</label
            >
            <input
              type="text"
              [ngModel]="projectDetail.name"
              (ngModelChange)="projectDetail.name = $event"
              class="form-control form-control-lg"
              id="projectName"
              placeholder="O'Hare Restrooms"
              disabled
              readonly
              />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="estimatedInstallDate" class="form-label">
                {{ "projectDetails.estimatedInstallDate" | cxTranslate }}</label
                >
                <input
                  type="text"
                  value="{{ convertDate(projectDetail.cpqInstallationDate) }}"
                  class="form-control"
                  id="estimatedInstallDate"
                  disabled
                  readonly
                  />
                </div>
                <div class="col-md-6">
                  <label for="cpqVerticalId" class="form-label">
                    {{ "projectDetails.vertical" | cxTranslate }}</label
                    >
                    <select
                      id="cpqVerticalId"
                      [ngModel]="projectDetail.cpqVerticalId"
                      (ngModelChange)="projectDetail.cpqVerticalId = $event"
                      class="form-control"
                      disabled
                      readonly
                      >
                      @for (vertical of verticals$ | async; track vertical) {
                        <option
                          [value]="vertical.verticalId"
                          >
                          {{ vertical.verticalName }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
                <h5 class="titleSec">
                  {{ "projectDetails.projectLocation" | cxTranslate }}
                </h5>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label for="streetAddress1" class="form-label">
                      {{ "projectDetails.streetAddress1" | cxTranslate }}</label
                      >
                      @if (projectDetail.deliveryAddress) {
                        <input
                          type="text"
                          [ngModel]="projectDetail.deliveryAddress.line1"
                          (ngModelChange)="projectDetail.deliveryAddress.line1 = $event"
                          class="form-control"
                          id="streetAddress1"
                          placeholder="111 Main Street"
                          disabled
                          readonly
                          />
                      }
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-12">
                      <label for="streetAddress2" class="form-label">
                        {{ "projectDetails.streetAddress2" | cxTranslate }}</label
                        >
                        @if (projectDetail.deliveryAddress) {
                          <input
                            type="text"
                            [ngModel]="projectDetail.deliveryAddress.line2"
                            (ngModelChange)="projectDetail.deliveryAddress.line2 = $event"
                            class="form-control"
                            id="streetAddress2"
                            placeholder="Suite 1111"
                            disabled
                            readonly
                            />
                        }
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-12">
                        <label for="country" class="form-label">
                          {{ "projectDetails.country" | cxTranslate }}</label
                          >
                          @if (projectDetail.deliveryAddress.country) {
                            <select
                              id="country"
                              class="form-control"
                              [ngModel]="projectDetail.deliveryAddress.country.isocode"
                              (ngModelChange)="projectDetail.deliveryAddress.country.isocode = $event"
                              disabled
                              readonly
                              >
                              @for (country of countries$ | async; track country) {
                                <option
                                  [value]="country.isocode"
                                  >
                                  {{ country.name }}
                                </option>
                              }
                            </select>
                          }
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                          <label for="zipCode" class="form-label">
                            {{ "projectDetails.zipCode" | cxTranslate }}</label
                            >
                            @if (projectDetail.deliveryAddress) {
                              <input
                                type="text"
                                [ngModel]="projectDetail.deliveryAddress.postalCode"
                                (ngModelChange)="projectDetail.deliveryAddress.postalCode = $event"
                                class="form-control"
                                id="zipCode"
                                disabled
                                readonly
                                />
                            }
                          </div>
                          <div class="col-md-4">
                            <label for="town" class="form-label">
                              {{ "projectDetails.city" | cxTranslate }}</label
                              >
                              @if (projectDetail.deliveryAddress) {
                                <input
                                  type="text"
                                  [ngModel]="projectDetail.deliveryAddress.town"
                                  (ngModelChange)="projectDetail.deliveryAddress.town = $event"
                                  class="form-control"
                                  id="town"
                                  disabled
                                  readonly
                                  />
                              }
                            </div>
                            <div class="col-md-4 mb-3">
                              <label for="state" class="form-label">
                                {{ "projectDetails.stateOrProvince" | cxTranslate }}</label
                                >
                                @if (projectDetail.deliveryAddress.region) {
                                  <select
                                    id="state"
                                    [ngModel]="projectDetail.deliveryAddress.region.isocode"
                                    (ngModelChange)="projectDetail.deliveryAddress.region.isocode = $event"
                                    class="form-control"
                                    disabled
                                    readonly
                                    >
                                    @for (state of regions$ | async; track state) {
                                      <option
                                        [value]="state.isocode"
                                        >
                                        {{ state.name }}
                                      </option>
                                    }
                                  </select>
                                }
                              </div>
                            </div>
                            <h5 class="titleSec">
                              {{ "projectDetails.notes" | cxTranslate }}
                            </h5>
                            <div class="row mb-3">
                              <div class="col-md-12">
                                <textarea
                                  class="form-control"
                                  [ngModel]="projectDetail.description"
                                  (ngModelChange)="projectDetail.description = $event"
                                  rows="3"
                                  disabled
                                  readonly
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
